import * as moment from 'moment';
import { IMatchDeadline } from '@nkr/models/index';
import MyDTPicker from '@nkr/components/date-time-picker-with-close-button';
import { Button } from 'react-bootstrap';
import { useEffect, useState } from 'react';

interface IProps {
    data: IMatchDeadline,
    onUpdateDeadline: (id: number, deadline: string) => void,
    onConfirmNoResponse: (id: number) => void,
}

const DeadlineRow = (props: IProps) => {
    const [deadline, setDeadline] = useState('');

    useEffect(() => {
        setDeadline(props.data.deadlineDateTime);
    }, [props.data])

    const handleNoResponse = () => {
        props.onConfirmNoResponse(props.data.id);
    };

    const handleEmailCenter = () => {
        // window.open(__OUTSIDEURL__ + '/admin/email_centers.php?mode=byMissedDeadline&id=' + props.data.recipientId);
        window.open('/admin/email?mode=byMissedDeadline&id=' + props.data.recipientId);
    };

    const handleDateTimeChange = (value: any) => {
        let newDeadline = typeof value != 'string' ? value.format('MM/DD/YYYY HH:mm') : value;
        setDeadline(newDeadline);
    };

    const handleDateTimeClose = () => {
        props.onUpdateDeadline(props.data.id, deadline);
    };

    const { chainId, clusterNumber, positionNumber, donorCenter, donorAlias, recipientCenter, recipientAlias, recipientAvoids } = props.data;

    const deadlineDateTime = moment(props.data.deadlineDateTime, 'MM/DD/YYYY HH:mm');
    const isLate = deadlineDateTime.isBefore(moment());

    return (
        <tr>
            <td>{chainId}</td>
            <td>{clusterNumber}</td>
            <td>{positionNumber}</td>
            <td>{donorCenter}</td>
            <td>{donorAlias}</td>
            <td>{recipientCenter}</td>
            <td>{recipientAlias}</td>
            <td>{recipientAvoids}</td>
            <td>
                <MyDTPicker
                    useCloseButton={true}
                    dateFormat='MM/DD/YYYY'
                    timeFormat='HH:mm'
                    inputProps={{ className: 'form-control input-sm', style: { backgroundColor: isLate ? 'red' : 'initial', color: isLate ? 'white' : 'initial' } }}
                    value={deadline}
                    onChange={handleDateTimeChange}
                    onClose={handleDateTimeClose}
                />
            </td>
            <td>
                <Button bsSize='sm' onClick={handleNoResponse}>No Response</Button>&nbsp;
                <Button bsSize='sm' onClick={handleEmailCenter}>Email Center</Button>
            </td>
        </tr>
    );
}

export default DeadlineRow;